import { useCurrentRefinements } from 'react-instantsearch';
import { useTranslation } from 'react-i18next';

const formatLabel = (attribute, refinement, t) => {
    const formattedAttribute = t(`listings.filters.attributes.${attribute}`) || attribute;

    if (refinement.type === 'numeric') {
        let value;
        if (attribute === 'price') {
            value = new Intl.NumberFormat('da-DK', {
                style: 'currency',
                currency: 'DKK',
                maximumFractionDigits: 0,
            }).format(refinement.value);
        }else  if (attribute === 'construction_year_quarter') {
            const year = Math.floor(refinement.value / 10); // Extract the first four digits as the year
            const quarter = refinement.value % 10; // Extract the last digit as the quarter

            // Format as "YYYY QX"
            return `${year} Q${quarter}`;
        } else if (attribute === 'living_area') {
            value = `${refinement.value}m²`;
        } else {
            value = refinement.value;
        }

        return `${formattedAttribute}: ${refinement.operator === '>=' ? '≥' : '≤'} ${value}`;
    }

    // Handle feature translations
    if (attribute === 'features') {
        // Try to find translation in various feature categories
        const featureCategories = ['outdoor', 'interior', 'wellness', 'characteristics', 'technology', 'community'];
        const featureKey = refinement.label || refinement.value;

        let translatedValue = '';
        for (const category of featureCategories) {
            const translation = t(`listings.filters.features.${category}.${featureKey}`, { defaultValue: '' });
            if (translation) {
                translatedValue = translation;
                break;
            }
        }

        // Fallback to the original value if no translation found
        translatedValue = translatedValue || featureKey;
        return `${formattedAttribute}: ${translatedValue}`;
    }

    return `${formattedAttribute}: ${refinement.label || refinement.value}`;
};

const CustomCurrentRefinements = () => {
    const { t } = useTranslation('common');
    const { items, refine } = useCurrentRefinements();
    
    // Count total refinements
    const totalRefinements = items.reduce((count, item) => count + item.refinements.length, 0);
    
    // If there are no refinements, don't render anything
    if (totalRefinements === 0) {
        return null;
    }

    return (
        <div className="flex flex-wrap gap-2">
            {items.map((item) => (
                item.refinements.map((refinement) => (
                    <span
                        key={`${item.attribute}-${refinement.value}`}
                        className="m-1 inline-flex items-center rounded-full border border-gray-200 bg-white py-1.5 pl-3 pr-2 text-xs font-medium text-gray-900"
                    >
                        <span>{formatLabel(item.attribute, refinement, t)}</span>
                        <button
                            onClick={(event) => {
                                event.preventDefault();
                                refine(refinement);
                            }}
                            type="button"
                            className="ml-1 inline-flex size-4 shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500"
                        >
                            <span className="sr-only">
                                {t('listings.filters.removeFilter')} {formatLabel(item.attribute, refinement, t)}
                            </span>
                            <svg className="size-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
                                <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
                            </svg>
                        </button>
                    </span>
                ))
            ))}
        </div>
    );
};

export default CustomCurrentRefinements;